import { Routes, Route } from 'react-router-dom'
import HomeBarbe from '../barbeiroView/HomeBarbe';
import HomeCli from '../clienteView/HomeCli';
import LoginCli from '../clienteView/LoginCli';
import PageBarber from '../startView/PageBarber';
import Payment from '../clienteView/Payment';
import Agendamentos from '../clienteView/Agendamendo';
import LoginBarbe from '../barbeiroView/LoginBarbe';
import Private from './Private'


function RoutesApp() {
  return(
    <Routes>
      <Route path='/' element={ <PageBarber/> } />
      <Route path='/loginCli' element={ <LoginCli/> } />
      <Route path='/homeCli' element={ <Private> <HomeCli/> </Private> } />
      <Route path='/payment' element={ <Private> <Payment/> </Private> } />
      <Route path='/agendamentos' element={ <Private> <Agendamentos/> </Private> } />
      <Route path='/loginBarber' element={ <LoginBarbe/>} />
      <Route path='/homeBarbe' element={ <Private> <HomeBarbe/> </Private> } />
    </Routes>
  )
}

export default RoutesApp;